import { render, staticRenderFns } from "./Questionbank.vue?vue&type=template&id=c22ebe78&scoped=true"
import script from "./Questionbank.vue?vue&type=script&lang=js"
export * from "./Questionbank.vue?vue&type=script&lang=js"
import style0 from "./Questionbank.vue?vue&type=style&index=0&id=c22ebe78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22ebe78",
  null
  
)

export default component.exports